import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '../_services/local-storage.service';
import { Subject } from 'rxjs';
import { HireFilterComponent } from '../hire-person-search/hire-filter/hire-filter.component';
import { HireJdSearchComponent } from '../hire-person-search/hire-jd-search/hire-jd-search.component';
import { FilterStoreService } from '../hire-person-search/store/filter-store.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { PersonSearchService } from '../_services/person-search.service';
import { JdDataService } from '../jd-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HashService } from '../_services/hash.service';
import { FilterResponseMapperServiceService } from '../hire-person-search/filter-response-mapper-service.service';
import { AggregateRequestStoreService } from '../hire-person-search/store/aggregate-request-store.service';
import { RequestServiceService } from '../hire-person-search/request-service.service';
import { Location } from '@angular/common';
import { HireQuickSearchComponent } from './hire-quick-search/hire-quick-search.component';
import { GeneralConstants } from '../constants/GeneralConstants';
import { SearchHistoryComponent } from '../search-history/search-history.component';


@Component({
  selector: 'app-hire-talent-insights',
  templateUrl: './hire-talent-insights.component.html',
  styleUrl: './hire-talent-insights.component.scss',
  standalone: false
})

export class HireTalentInsightsComponent {
  username: string;
  defaultContinent: string = null;
  showNewWayHiringBanner: boolean = true
  searchText = '';
  searchKeyword: string = '';
  successMessage: string = '';
  errorMessage: string = '';
  historySubject: Subject<any> = new Subject<any>();
  savedHistorySubject: Subject<any> = new Subject<any>();
  constructor(
    private localStorageService: LocalStorageService,
    private filterStoreService: FilterStoreService,
    private modalService: NgbModal,
    private filterDataHandlerService: FilterDataHandlerService, private personSearchService: PersonSearchService, private jdDataService: JdDataService, private router: Router,
    private hashService: HashService, private route: ActivatedRoute, private location: Location,
    private filterResponseMapperService: FilterResponseMapperServiceService, private aggregateRequestStoreService: AggregateRequestStoreService, private requestService: RequestServiceService
  ) { }
  ngOnInit() {
    this.username = this.localStorageService.getItem('ufname');
  }
  openAdvancedSearch(type?: string) {
    this.localStorageService.setItem('nlSearchKeyword', this.searchKeyword);
    this.filterStoreService.setFilter({ 'nlsearchquery': this.searchKeyword });
    this.filterStoreService.setFilter({ 'booleanquery': this.searchKeyword });
    const modalRef = this.modalService.open(HireFilterComponent, { windowClass: 'hireFiltermodal', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.nlSearchType = 'nlSearch'
    modalRef.componentInstance.calledFrom = 'talent-insights';
    // modalRef.componentInstance.keywordtype = type;
    // modalRef.componentInstance.nlsearchKeyword = this.searchKeyword;

  }

  openJobDescription() {
    this.localStorageService.setItem('nlSearchKeyword', null);
    const modalRef = this.modalService.open(HireJdSearchComponent, { size: 'md', windowClass: 'modal-size button-place', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.calledFrom = 'talent-insights';
  }
  openQuickSearch() {
    const modalRef = this.modalService.open(HireQuickSearchComponent, { windowClass: 'modal-size button-place quicksearchmodal', centered: true, keyboard: false });
  }

  openSearchResult(type?: string) {
    if (this.searchKeyword?.length > 2000) {
      return;
    }
    this.localStorageService.setItem('nlSearchKeyword', this.searchKeyword);
    this.filterStoreService.setFilter({ 'nlsearchquery': this.searchKeyword });
    this.aggregateRequestStoreService.userQuery.set(this.searchKeyword);
    this.aggregateRequestStoreService.loading.set(true);
    this.redirectToSearchResults();
  }

  redirectToSearchResults() {
    this.router.navigate(
      ['/talent-insights/overview'],
      {
        queryParams: {
          type: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH,
        },
      }
    );

  }

  openSearchHistory() {
    const modalRef = this.modalService.open(SearchHistoryComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.calledFrom = 'mainscreen';
    modalRef.componentInstance.openModal = true;
    modalRef.componentInstance.currentModule = 'talent-insights';

  }

}
